<template>
  <div class="widget" ref="widget_body">
    <DialogWidget
      v-if="dialog"
      :dialog.sync="dialog"
      :widget="widget"
    ></DialogWidget>
    <CommonDialog
      :dialog="dialogDelete"
      :head-text="$t(`widgets.delete-title`)"
      :content-text="$t(`widgets.delete-dialog`)"
      :confirm-button="{
        text: $t('widgets.delete'),
        icon: 'mdi-trash-can-outline'
      }"
      :on-confirm="deleteItem"
      :on-cancel="
        () => {
          dialogDelete = false;
        }
      "
    ></CommonDialog>
    <div class="menu">
      <v-btn
        v-if="!$vuetify.breakpoint.mdAndDown"
        icon
        v-on:click="$refs.MeterAnalysis.resetZoom()"
      >
        <v-icon>mdi-magnify-remove-outline</v-icon>
      </v-btn>
      <v-btn icon v-on:click="dialog = true">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
      <v-btn icon v-on:click="dialogDelete = true">
        <v-icon>mdi-trash-can-outline</v-icon>
      </v-btn>
    </div>
    <template v-if="item.type === 'chart'">
      <MeterAnalysis
        ref="MeterAnalysis"
        :meter_id="item.meter"
        :project_id="item.project"
        :options="item.options"
        need-group-breadcrumbs
        :need-reset-button="false"
      ></MeterAnalysis>
    </template>
  </div>
</template>

<script>
import MeterAnalysis from "../analysis/MeterAnalysis";
import CommonDialog from "../common/dialogs/CommonDialog";
import DialogWidget from "./DialogWidget";
export default {
  name: "Widget",
  components: { MeterAnalysis, CommonDialog, DialogWidget },
  data: () => ({
    dialog: false,
    dialogDelete: false
  }),
  props: {
    widget: {}
  },
  methods: {
    deleteItem() {
      this.dialogDelete = false;
      this.$store.dispatch("dashboardStore/delete", { widget: this.widget });
    }
  },
  computed: {
    item() {
      let options = this.widget.item.options;
      if (
        this.widget.item &&
        this.widget.item.options &&
        this.widget.item.options.dateTitle
      ) {
        let quickSelect = this.$store.getters[
          "dashboardStore/getRelativeIntervals"
        ];
        let optionsFromInterval = quickSelect
          .reduce((ac, i) => [...ac, ...i.items], [])
          .find(i => i.title === this.widget.item.options.dateTitle);
        options = { ...this.widget.item.options, ...optionsFromInterval.item };
      }
      return { ...this.widget.item, options } || {};
    }
  },
  mounted() {
    let calcSize = () => {
      let h = Math.ceil(
        (this.$refs.widget_body || { offsetHeight: 0 }).offsetHeight / 30
      );
      if (this.widget.h !== h) {
        this.$store.dispatch("dashboardStore/edit", {
          widget: {
            ...this.widget,
            h
          }
        });
      }
    };
    calcSize();
    new ResizeObserver(calcSize).observe(this.$refs.widget_body);
  }
};
</script>

<style scoped>
.widget {
  position: relative;
}
.menu {
  position: absolute;
  right: 0;
  top: 6px;
  z-index: 1;
}
</style>
